import { LumappsTrackingEventContext } from '@lumapps/analytics-tracking/types';
import { AskAiFeedbackReasonTypes, AskAiFeedbackTypes } from '@lumapps/ask-ai/types';
import { SearchFeedbackTypes } from '@lumapps/search-page/type';
import { SearchType } from '@lumapps/search/types';

export enum TargetType {
    ASK_REACTION = 'ask_reaction',
    SEARCH_REACTION = 'search_reaction',
}

/**
 **************** *
 * Users feedback *
 ******************
 */

/** Fields common to all user feedback */
type CommonLumappsUserFeedback = {
    traceId: string;
    comment?: string;
};

/** Data to send with analytics to describe what results was sent at the moment of the feedback.  */
export type UserFeedbackSearchResultsDetails = { title: string; url: string };

// Ask
export type LumappsTrackingAskReaction = CommonLumappsUserFeedback & {
    type: TargetType.ASK_REACTION;
    reactionType: AskAiFeedbackTypes;
    feedbackReason?: AskAiFeedbackReasonTypes;
    sources?: UserFeedbackSearchResultsDetails[];
};

// Search
export type LumappsTrackingSearchReaction = CommonLumappsUserFeedback & {
    type: TargetType.SEARCH_REACTION;
    reactionType: SearchFeedbackTypes;
    searchType: SearchType;
    results?: UserFeedbackSearchResultsDetails[];
};

// General types
export type LumappsUserFeedbackActionType = LumappsTrackingSearchReaction | LumappsTrackingAskReaction;

export interface LumappsUserFeedbackEvent {
    action: LumappsUserFeedbackActionType;
    sessionId: string;
    performedAt: string;
    context: LumappsTrackingEventContext;
}

export interface LumappsUserFeedbackEventPayload {
    action: LumappsUserFeedbackActionType;
}
